import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { type AdminSearchCacheClearResult, clearSearchCache } from '~/services/ReproduceSearchService';

function countDeletedLlmOperations(result: AdminSearchCacheClearResult): number {
  return result.llm_cache.operations.filter((operation) => operation.deleted).length;
}

function countDeletedObjectCaches(result: AdminSearchCacheClearResult): number {
  return result.object_caches.filter((entry) => entry.deleted).length;
}

export function useClearSearchCache() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (body: Parameters<typeof clearSearchCache>[0]) => clearSearchCache(body),
    onSuccess: (result) => {
      const llmDeleted = countDeletedLlmOperations(result);
      const objectDeleted = countDeletedObjectCaches(result);

      enqueueSnackbar(
        `Cache reset complete: ${llmDeleted} LLM and ${objectDeleted} ObjectCache entries deleted (${result.duration_ms}ms)`,
        { variant: 'success' },
      );

      result.warnings.forEach((warning) => {
        enqueueSnackbar(warning, { variant: 'warning' });
      });
    },
    onError: (error: Error) => {
      enqueueSnackbar(error.message || 'Failed to reset search cache', { variant: 'error' });
    },
  });
}
